export enum DeliveryOptions {
    SendToEInvoicesAPI = 1,
    SendToEInvoicesAPIAndEmail = 2,
    SendToEmail = 3
}
